module.exports = __webpack_public_path__ + "img/nap_m_01.c8ed1afe.jpg";